import { Building2, MapPin, Users } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { Chip } from '../compass/shared';

// Section 14 — multi-site visibility and permissions: a simple, honest
// role-and-site relationship composition (no fabricated permission configs).
export const ForeseeSites = ({ sp }) => (
  <section aria-labelledby="foresee-sites-heading" data-testid="foresee-sites" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="14"
        eyebrow="Multi-Site & Permissions"
        title="One platform across teams, sites and responsibilities"
        testid="foresee-sites-header"
      />
      <Reveal className="mt-12">
        <div className="rounded-2xl border border-slate-200 bg-mist p-8 sm:p-10">
          <div className="grid items-center gap-8 md:grid-cols-3">
            <div className="rounded-xl bg-navy-900 p-6 text-center">
              <Building2 className="mx-auto h-6 w-6 text-gold-500" aria-hidden="true" />
              <h3 className="mt-3 text-sm font-extrabold uppercase tracking-widest text-white">Group level</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-slate-300">Central reporting and cross-site visibility for management.</p>
            </div>
            <div className="rounded-xl border border-indigo-200 bg-indigo-50/60 p-6 text-center">
              <MapPin className="mx-auto h-6 w-6 text-indigo-600" aria-hidden="true" />
              <h3 className="mt-3 text-sm font-extrabold uppercase tracking-widest text-navy-900">Site level</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-slate-600">Site-level reporting, actions and compliance activity where work happens.</p>
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-6 text-center">
              <Users className="mx-auto h-6 w-6 text-gold-700" aria-hidden="true" />
              <h3 className="mt-3 text-sm font-extrabold uppercase tracking-widest text-navy-900">People</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-slate-600">Role-based access for frontline users, managers and client administrators.</p>
            </div>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-2" data-testid="foresee-sites-points">
            {(sp.sitesPoints || []).map((point) => <Chip key={point}>{point}</Chip>)}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
